export const reviews = [
    {
      "name": "Amanda Tannenbaum",
    //   "date": new Date(2022, 12),
      "review" : "The best tailor / seamstress. I've taken two very intricate dresses here for hems and alterations and they both came out perfect. Not even slightly off. PERFECT. And they're reasonably priced. But cash only!! HIGHLY RECOMMEND. So nice and fast too.",
      "rating" : 5,
    },
    {
        "name": "Theana Cheliotes",
      //   "date": new Date(2022, 12),
        "review" : "Quick, easy and reasonable! My boys looked so handsome in their suits!",
        "rating" : 5,
      },
      {
        "name": "Yael W.",
      //   "date": new Date(2022, 12),
        "review" : "Fast and affordable service! Had my dress shortened and was very happy with the result. Iris is great!",
        "rating" : 5,
      },
      {
        "name": "Regina Baker",
      //   "date": new Date(2022, 12),
        "review" : "What sn excellent tailor!! She can alter anything. And she is quick as well!",
        "rating" : 5,
      },
      {
        "name": "P A",
      //   "date": new Date(2022, 12),
        "review" : "Great service and quick turnaround",
        "rating" : 5,
      },
  ]

